export default __webpack_public_path__ + "static/media/news-white.2814222d.svg";